<div class="ne-message-container">
  <Radio
    {id}
    value="{text}"
    text="{text}"
    checked="{isSelected}"
    choose="{event => choose(event)}" />
</div>

<style>
  .ne-message-container {
    margin-bottom: .5em;
    border-radius: .25em;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto;
    position: relative;
  }
</style>

 <script>
   import Radio from './Radio.html';

   export let id;
   export let text;
   export let isSelected;
   export let choose;
 </script>
